import { Component } from '@angular/core';
import { RevealDirective } from '../../../directives/reveal.directive';

@Component({
  selector: 'app-app-cta',
  standalone: true,
  imports: [RevealDirective],
  templateUrl: './app-cta.component.html',
})
export class AppCtaComponent {}
